import { ObjectId } from '@freightview/object-id'

import type { FreightClass, Mode, Workflow } from '@fv/models'
import { freightClasses } from '@fv/models'

import type { ApiLoadHandlingUnitDTO } from '@/types/api-dto'

import type { FormCommodity } from './FormCommodity'
import { buildHandlingUnitDTO } from './load-items/loadItemHelpers'

export const modeToWorkflow = (mode: Mode): Workflow =>
  mode === 'parcel' || mode === 'truckload' || mode === 'ltl' ? mode : 'ltl'

const toFreightClass = (value: string): FreightClass | undefined =>
  freightClasses.find(c => c === Number(value))

export function buildApiHandlingUnitFromFormCommodity(
  item: FormCommodity,
  mode: Mode,
): ApiLoadHandlingUnitDTO {
  return buildHandlingUnitDTO(modeToWorkflow(mode))({
    _id: item.id,
    description: item.description.trim(),
    dimensionsUOM: item.dimensionsUOM,
    dropLocationSequence: item.dropSequence,
    fullNmfc: item.nmfc,
    handlingUnitType: 'single',
    isHazardous: item.hazardous === 'Yes',
    pickupLocationSequence: item.pickSequence,
    quantity: Number(item.quantity),
    type: item.type,
    weight: Number(item.weight),
    weightUOM: item.weightUOM,
    ...(item.declaredValue && {
      declaredValue: Number(item.declaredValue),
      declaredValueCurrency: item.declaredValueCurrency,
    }),
    ...(item.freightClass && {
      freightClass: toFreightClass(item.freightClass),
    }),
    ...(item.handlingUnitId && { handlingUnitId: item.handlingUnitId }),
    ...(item.height && { height: Number(item.height) }),
    ...(item.length && { length: Number(item.length) }),
    ...(item.width && { width: Number(item.width) }),
    ...(item.nonStandard === 'Yes' && { nonStandard: true }),
    ...(item.stackable === 'Yes' && { stackable: true }),
    ...(item.hazardous === 'Yes' && {
      hazardous: {
        packingGroup: item.packingGroup,
        primaryClass: item.primaryClass,
        secondaryClass: item.secondaryClass,
        tertiaryClass: item.tertiaryClass,
        reportableQuantity: item.reportableQuantity,
        residueLastContained: item.residueLastContained,
        limitedQuantity: item.limitedQuantity,
        marinePollutant: item.marinePollutant,
        hazmatId: item.hazmatId?.trim(),
        permitNumber: item.permitNumber?.trim(),
        properShippingName: item.properShippingName?.trim(),
        technicalName: item.technicalName?.trim(),
      },
    }),
    ...(item.saidToContain && {
      contains: [
        {
          _id: new ObjectId().toHexString(),
          description: '',
          quantity: Number(item.saidToContain),
          type: item.saidToContainPackagingType || 'unit',
        },
      ],
    }),
  })
}
